<template>
  <b-form-group
    label="Sadaka & Zekat"
    label-for="id_donation_types"
  >
    <v-select
      id="id_donation_types"
      v-model="filterParams.id_donation_types"
      :options="donationTypes"
      label="title"
      :reduce="item => item.id"
      placeholder="Tümü"
    />
  </b-form-group>
</template>
<script>
import vSelect from 'vue-select'
import { BFormGroup } from 'bootstrap-vue'

export default {
  name: 'DonationTypes',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    donationTypes() {
      return this.$store.getters['donationTypes/dataList']
    },
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
  },
  created() {
    this.getDonationTypes()
  },
  methods: {
    getDonationTypes() {
      this.$store.dispatch('donationTypes/getDataList')
    },
  },
}
</script>
